// @flow
import { Record, Map as ImmutableMap } from 'immutable';
import type { RecordOf, RecordFactory } from 'immutable';

import { mkChartOfAccount } from 'data/chartOfAccounts/types';

import type { QcsSyncResourceStoreProps } from 'data/qcsSyncResourceTypes';

// ================================================================================================
// Rename MemorizedRules STore
// ================================================================================================

type MemorizedRulesStoreProps = QcsSyncResourceStoreProps & {

};
export type MemorizedRulesStore = RecordOf<MemorizedRulesStoreProps>;
export const mkMemorizedRulesStore: RecordFactory<MemorizedRulesStoreProps> =
  Record({
    resourcesById: ImmutableMap(),

    lastSyncDate: null,
    loadPending: true,

    isLoading: false,
  });

type MemorizedRuleProps = {
  id: string,
  clientId: ?string,
  isDeleted: ?boolean,
  payee: string,
  transactionType: string,
  memo: ?string,
  amount: ?string,
  isNotAutoCategorized: ?boolean,
  isNotEditableByTransactions: ?boolean,
  isExcludedFromCalendar: ?boolean,
  coa: any,
  tags: ?Array,
  split: any,

};
export type MemorizedRule = RecordOf<MemorizedRuleProps>;

export const mkMemorizedRule: RecordFactory<MemorizedRuleProps> =
  Record({
    id: null,
    clientId: null,
    isDeleted: false,
    payee: '',
    transactionType: 'PAYMENT',
    memo: '',
    amount: '0',
    isNotAutoCategorized: false,
    isNotEditableByTransactions: false,
    isExcludedFromCalendar: true,
    coa: mkChartOfAccount({
      id: '0',
      type: 'UNCATEGORIZED',
    }),
    tags: null,
    split: undefined,
  });

